import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import EggsProduct from 'models/EggsProduct'
import React, { useContext, useEffect, useState } from 'react'
import Switch from 'react-switch'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'

const EggsPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { setSwitch, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        ContainerSize,
        CASEFSCompliantCertification,
        EggShellColorCertification,
      } = current
      setPackaging({
        category,
        subCategory,
        ContainerSize,
        CASEFSCompliantCertification,
        EggShellColorCertification,
      })
    } else if (!updating) {
      setCurrent(EggsProduct)
    }
    // eslint-disable-next-line
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Input defaultValue={packaging.ContainerSize} disabled />
        </FormGroup>
      </Col>
      <Col xs={6}>
        <p>
          <strong>
            I verify that this product is CA SEFS Compliant. A product
            image displaying this compliance seal is uploaded below.
            {' '}
            {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="CASEFSCompliantCertification"
          id="CASEFSCompliantCertification"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.CASEFSCompliantCertification}
          rules={{
            validate: CASEFSCompliantCertification =>
              CASEFSCompliantCertification === true,
          }}
        />
        <br />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="CASEFSCompliantCertification"
            message={'⚠ Product must be CA SEFS Compliant.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <hr />
        <p>
          <strong>
            I confirm that the egg shell color is white. A product image
            displaying the color of the egg shell is uploaded below.
            {' '}
            {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="EggShellColorCertification"
          id="EggShellColorCertification"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.EggShellColorCertification}
          rules={{
            validate: EggShellColorCertification =>
              EggShellColorCertification === true,
          }}
        />
        <br />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="EggShellColorCertification"
            message={'⚠ Egg shell color must be white.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

export default EggsPackage

export const getEggsPackage = newProduct => {
  const newEggsPackage = {
    UPC: newProduct.UPC,
    ContainerSize: newProduct.ContainerSize,
    CASEFSCompliantCertification: newProduct.CASEFSCompliantCertification,
    EggShellColorCertification: newProduct.EggShellColorCertification,
  }
  return newEggsPackage
}

export const updateEggsPackage = newProduct => {
  const newEggsPackage = {
    UPC: newProduct.UPC,
    ContainerSize: newProduct.ContainerSize,
    CASEFSCompliantCertification: newProduct.CASEFSCompliantCertification,
    EggShellColorCertification: newProduct.EggShellColorCertification,
  }
  return newEggsPackage
}
